import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { ThirdPartyPayoff } from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface ProposeThirdPartyPayoffRemovalRequest {
    engagementId: number;
    tableRowId: number;
    /** Required — the modal will not submit without it. */
    comment: string;
}

export const ProposeThirdPartyPayoffRemoval = createAsyncThunk(
    'flowOfFunds/proposeThirdPartyPayoffRemoval',
    async (params: ProposeThirdPartyPayoffRemovalRequest, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.post(
                `/api/flowOfFunds/${params.engagementId}/thirdPartyPayoffs/rows/${params.tableRowId}/removalProposal`,
                {
                    comment: params.comment,
                }
            );

            if (response.status !== 200) {
                throw new Error('Failed to propose the removal');
            }

            return response.data as ThirdPartyPayoff;
        } catch (error) {
            createNotification('Could not propose the removal.', 'error');
            throw error;
        }
    }
);
